import React from 'react';
import { renderToString } from 'react-dom/server';

import { ApIcon, colors } from '@alixpartners/ui-components';
import { Wrapper } from './IconCellRenderer.styles';

export const IconCellRenderer = () => {
	return renderToString(
		<Wrapper>
			<ApIcon iconName="outline_info" iconColor={colors.grey5} iconSize={16} />
		</Wrapper>
	);
};
